import update from 'immutability-helper';

import {
  GET_COLLECTION,
  CLEAR_COLLECTION,
  SET_COLLECTION_LOADING,
  GET_COLLECTION_GROUPS,
  GET_COLLECTION_GROUPS_ARCHIVED,
  SET_COLLECTION_GROUPS_LOADING,
  GET_COLLECTIONS,
  SET_COLLECTIONS_LOADING,
  GET_ALL_COLLECTIONS,
  CLEAR_COLLECTIONS,
  CLEAR_COLLECTIONS_LIST,
  SET_COLLECTIONS_END,
  SHOW_COLLECTION_EDIT_MODAL,
  HIDE_COLLECTION_EDIT_MODAL,
  SHOW_COLLECTION_ADD_MODAL,
  HIDE_COLLECTION_ADD_MODAL,
  SHOW_COLLECTION_MOVE_MODAL,
  HIDE_COLLECTION_MOVE_MODAL,
  UPDATE_COLLECTION_ON_COLLECTIONS_LIST,
  UPDATE_COLLECTION_LIKES_ON_COLLECTIONS_LIST,
  DELETE_COLLECTION_FROM_COLLECTIONS_LIST,
  DELETE_COLLECTIONS_FROM_COLLECTIONS_LIST,
  UPDATE_CURRENT_COLLECTION,
  SET_COLLECTIONS_ORDER,
  SET_COLLECTION_GROUP,
  SET_COLLECTION_FILTERS,
  SET_SELECTED_COLLECTION_FILTERS,
  CLEAR_COLLECTION_FILTERS,
  ADD_SELECTED_COLLECTION_FILTER,
  REMOVE_SELECTED_COLLECTION_FILTER,
  CLEAR_SELECTED_COLLECTION_FILTERS,
  SET_COLLECTIONS_PARAMS,
  CLEAR_COLLECTIONS_PARAMS,
  GET_AVAILABLE_COLLECTION_FILTERS,
  SET_COLLECTIONS_SEARCH_TYPE,
  SET_SIDEBAR_COLLECTION_OPEN,
  SET_SIDEBAR_COLLECTION,
  SET_SIDEBAR_COLLECTION_FILES,
  SET_SIDEBAR_COLLECTION_FILES_LOADING,
  ADD_FILES_TO_SIDEBAR_COLLECTION_FILES_LIST,
  REMOVE_FILES_FROM_SIDEBAR_COLLECTION_FILES_LIST,
  CLEAR_SIDEBAR_COLLECTION_FILES_LIST,
  SET_SIDEBAR_COLLECTION_UPDATE,
  SET_COLLECTION_GROUP_GROUPS,
  DELETE_COLLECTION_GROUP_GROUP_FROM_LIST,
  SET_SELECTED_COLLECTIONS,
  ADD_SELECTED_COLLECTION,
  ADD_SELECTED_COLLECTIONS,
  REMOVE_SELECTED_COLLECTION,
  CLEAR_SELECTED_COLLECTIONS,
  SET_SELECTED_ALL_COLLECTIONS,
  SHOW_COLLECTION_GROUP_EDIT_MODAL,
  HIDE_COLLECTION_GROUP_EDIT_MODAL,
  UPDATE_COLLECTIONS_TREE,
  ADD_COLLECTION_TO_TREE,
  UPDATE_COLLECTION_ON_TREE,
  REMOVE_COLLECTION_FROM_TREE,
  CLEAR_COLLECTIONS_TREE,
  SET_COLLECTIONS_TREE_LOADING,
  GET_FEATURED_COLLECTIONS,
  SET_FEATURED_COLLECTIONS_LOADING,
  SWAP_COLLECTIONS,
} from '../actions/Collections';

import { getParentCollection } from '../helpers/Collections';

const initialCollectionsParams = {
  page: 0,
  orderby: 'position',
  order: 'asc',
};

const initialCollectionsFilters = {
  visibility: [],
  user_ids: [],
  group_ids: [],
  date: null,
  date_from: null,
  date_to: null,
};

const initialCollectionsTree = {
  root: {
    index: 'root',
    name: 'Collections',
    hasChildren: true,
    children: [],
  },
};

const initialState = {
  collection: null,
  collectionGroupId: 0,
  collectionGroups: [],
  collectionGroupsArchived: [],
  collections: [],
  collectionsTotal: 0,
  collectionsEnd: false,
  editModal: false,
  addModal: false,
  moveModal: false,
  moveModalOpen: false,
  moveModalCollection: null,
  collectionGroupsLoading: false,
  collectionsLoading: false,
  collectionLoading: false,
  params: { ...initialCollectionsParams },
  filters: { ...initialCollectionsFilters },
  selectedFilters: [],
  availableFilters: {
    visibility: [],
    user_ids: [],
    group_ids: [],
    min_created_at: null,
  },
  searchType: 'new',
  sidebarCollectionOpen: false,
  sidebarCollection: null,
  sidebarCollectionFiles: [],
  sidebarCollectionFilesLoading: false,
  sidebarCollectionUpdate: false,
  collectionGroupGroups: [],
  selectedCollections: [],
  selectedAllCollections: false,
  collectionGroupEditModal: false,
  collectionsTree: {
    tree: {
      root: {
        index: 'root',
        name: '',
        hasChildren: true,
        children: [],
      },
    },
    overlay: {
      root: {
        index: 'root',
        name: '',
        hasChildren: true,
        children: [],
      },
    },
    sidebar: {
      root: {
        index: 'root',
        name: '',
        hasChildren: true,
        children: [],
      },
    },
  },
  collectionsTreeLoading: false,
  featuredCollections: [],
  featuredCollectionsLoading: true,
};

export const Collections = (state = initialState, action) => {
  switch (action.type) {
    case GET_COLLECTION:
      return Object.assign({}, state, {
        collection: action.collection,
      });

    case CLEAR_COLLECTION:
      return Object.assign({}, state, {
        collection: null,
      });

    case SET_COLLECTION_LOADING:
      return Object.assign({}, state, {
        collectionLoading: action.loading,
      });

    case GET_COLLECTION_GROUPS:
      return Object.assign({}, state, {
        collectionGroups: action.collectionGroups,
      });

    case GET_COLLECTION_GROUPS_ARCHIVED:
      return Object.assign({}, state, {
        collectionGroupsArchived: action.collectionGroups,
      });

    case SET_COLLECTION_GROUPS_LOADING:
      return Object.assign({}, state, {
        collectionGroupsLoading: action.loading,
      });

    case GET_COLLECTIONS:
      return Object.assign({}, state, {
        collections:
          action.collections === null ? [] : state.collections.concat(action.collections),
        collectionsTotal: action.total,
      });

    case SET_COLLECTIONS_LOADING:
      return Object.assign({}, state, {
        collectionsLoading: action.loading,
      });

    case GET_ALL_COLLECTIONS: {
      const {
        collectionGroupId,
        collections,
      } = action;
      const collectionGroupIndex = collectionGroupId ?
        state.collectionGroups.findIndex(cg => (cg.id === parseInt(collectionGroupId))) :
        state.collectionGroups.findIndex(cg => (cg.id === -1));

      return update(state, {
        collectionGroups: {
          [collectionGroupIndex]: {
            collections: {
              $set: collections,
            },
          },
        },
      });
    }

    case CLEAR_COLLECTIONS:
      return Object.assign({}, state, {
        collections: [],
        collectionsEnd: false,
        collectionsTotal: 0,
        params: { ...initialCollectionsParams, ...action.params },
      });

    case CLEAR_COLLECTIONS_LIST:
      return Object.assign({}, state, {
        collections: [],
        collectionsEnd: false,
        collectionsTotal: 0,
        params: Object.assign({}, state.params, { page: 0 }),
      });

    case SET_COLLECTIONS_END:
      return Object.assign({}, state, {
        collectionsEnd: action.end,
      });

    case SHOW_COLLECTION_EDIT_MODAL:
      return Object.assign({}, state, {
        editModal: true,
      });

    case HIDE_COLLECTION_EDIT_MODAL:
      return Object.assign({}, state, {
        editModal: false,
      });

    case SHOW_COLLECTION_ADD_MODAL:
      return Object.assign({}, state, {
        addModal: true,
        moveModal: action.move,
      });

    case HIDE_COLLECTION_ADD_MODAL:
      return Object.assign({}, state, {
        addModal: false,
      });

    case SHOW_COLLECTION_MOVE_MODAL:
      return Object.assign({}, state, {
        moveModalOpen: true,
        moveModalCollection: action.collection,
      });

    case HIDE_COLLECTION_MOVE_MODAL:
      return Object.assign({}, state, {
        moveModalOpen: false,
        moveModalCollection: null,
      });

    case UPDATE_COLLECTION_ON_COLLECTIONS_LIST: {
      let newCollections = state.collections.slice(0);
      const { collection } = action;
      const collectionIndex =
        state.collections.findIndex(c => (c.uuid === collection.uuid));
      if (collectionIndex > -1) {
        const parentCollection = getParentCollection(newCollections[collectionIndex]);
        const newParentCollection = getParentCollection(collection);
        if (
          (
            parentCollection && newParentCollection &&
            parentCollection.uuid === newParentCollection.uuid
          ) ||
          (!parentCollection && !newParentCollection)
        ) {
          newCollections[collectionIndex] = collection;
        } else {
          newCollections = newCollections.filter(c => (c.uuid !== collection.uuid));
        }
      }

      return Object.assign({}, state, {
        collections: newCollections,
      });
    }

    case UPDATE_COLLECTION_LIKES_ON_COLLECTIONS_LIST: {
      const newCollections = state.collections.slice(0);
      const { collection } = action;
      const collectionIndex =
        state.collections.findIndex(c => (c.uuid === collection.uuid));
      if (collectionIndex > -1) {
        newCollections[collectionIndex].likes = collection.likes;
        newCollections[collectionIndex].likes_count = collection.likes_count;
        newCollections[collectionIndex].liked = collection.liked;
      }

      return Object.assign({}, state, {
        collections: newCollections,
      });
    }

    case DELETE_COLLECTION_FROM_COLLECTIONS_LIST: {
      let newCollections = state.collections.slice(0);
      newCollections = newCollections.filter(c => (c.uuid !== action.collection.uuid));

      return Object.assign({}, state, {
        collections: newCollections,
      });
    }

    case DELETE_COLLECTIONS_FROM_COLLECTIONS_LIST: {
      let newCollections = state.collections.slice(0);
      action.collections.forEach((collection) => {
        newCollections = newCollections.filter(c => (c.uuid !== collection.uuid));
      });

      return Object.assign({}, state, {
        collections: newCollections,
      });
    }

    case UPDATE_CURRENT_COLLECTION:
      return Object.assign({}, state, {
        collection: Object.assign({}, state.collection, {
          name: action.collection.name,
          description: action.collection.description,
          featured: action.collection.featured,
          ancestors: action.collection.ancestors,
          subscribed: action.collection.subscribed,
          ...(action.collection.attributes &&
            {
              attributes: action.collection.attributes,
            }),
        }),
      });

    case SET_COLLECTIONS_ORDER:
      return Object.assign({}, state, {
        orderby: action.orderby,
        order: action.order,
      });

    case SET_COLLECTION_GROUP:
      return Object.assign({}, state, {
        collectionGroupId: parseInt(action.collectionGroupId),
      });

    case SET_COLLECTION_FILTERS:
      return Object.assign({}, state, {
        filters: Object.assign({}, state.filters, action.filters),
      });

    case SET_SELECTED_COLLECTION_FILTERS:
      return Object.assign({}, state, {
        selectedFilters: action.selectedFilters,
      });

    case CLEAR_COLLECTION_FILTERS:
      return Object.assign({}, state, {
        filters: {
          visibility: [],
          user_ids: [],
          group_ids: [],
          date: null,
          date_from: null,
          date_to: null,
        },
      });

    case ADD_SELECTED_COLLECTION_FILTER:
      return Object.assign({}, state, {
        selectedFilters: state.selectedFilters.concat([action.filter]),
      });

    case REMOVE_SELECTED_COLLECTION_FILTER: {
      if (action.filterKey) {
        return Object.assign({}, state, {
          selectedFilters: state.selectedFilters
            .filter(f => (!(f.key === `${action.filterKey}` && f.type === action.filterType))),
        });
      }
      return Object.assign({}, state, {
        selectedFilters: state.selectedFilters
          .filter(f => (f.type !== action.filterType)),
      });
    }

    case CLEAR_SELECTED_COLLECTION_FILTERS:
      return Object.assign({}, state, {
        selectedFilters: [],
      });

    case SET_COLLECTIONS_PARAMS:
      return Object.assign({}, state, {
        params: Object.assign({}, state.params, action.params),
      });

    case CLEAR_COLLECTIONS_PARAMS:
      return Object.assign({}, state, {
        params: { ...initialCollectionsParams, ...action.params },
      });

    case GET_AVAILABLE_COLLECTION_FILTERS: {
      if (Object.keys(action.filters).length > 0) {
        return Object.assign({}, state, {
          availableFilters: Object.assign({}, state.availableFilters, action.filters),
        });
      }
      return Object.assign({}, state, {
        availableFilters: initialState.availableFilters,
      });
    }

    case SET_COLLECTIONS_SEARCH_TYPE:
      return Object.assign({}, state, {
        searchType: action.searchType,
      });

    case SET_SIDEBAR_COLLECTION_OPEN:
      return Object.assign({}, state, {
        sidebarCollectionOpen: action.open,
      });

    case SET_SIDEBAR_COLLECTION:
      return Object.assign({}, state, {
        sidebarCollection: action.collection,
        sidebarCollectionUpdate: action.update,
      });

    case SET_SIDEBAR_COLLECTION_FILES:
      return Object.assign({}, state, {
        sidebarCollectionFiles: action.files,
      });

    case SET_SIDEBAR_COLLECTION_FILES_LOADING:
      return Object.assign({}, state, {
        sidebarCollectionFilesLoading: action.loading,
      });

    case SET_SIDEBAR_COLLECTION_UPDATE:
      return Object.assign({}, state, {
        sidebarCollectionUpdate: action.update,
      });

    case ADD_FILES_TO_SIDEBAR_COLLECTION_FILES_LIST: {
      const newFiles = state.sidebarCollectionFiles.slice(0);
      action.files.forEach((file) => {
        if (!newFiles.find(nf => (nf.uuid === file.uuid))) {
          newFiles.unshift(file);
        }
      });
      return Object.assign({}, state, {
        sidebarCollectionFiles: newFiles,
      });
    }

    case REMOVE_FILES_FROM_SIDEBAR_COLLECTION_FILES_LIST: {
      let newFiles = state.sidebarCollectionFiles.slice(0);
      action.files.forEach((file) => {
        newFiles = newFiles.filter(nf => (nf.uuid !== file.uuid));
      });
      return Object.assign({}, state, {
        sidebarCollectionFiles: newFiles,
      });
    }

    case CLEAR_SIDEBAR_COLLECTION_FILES_LIST: {
      return Object.assign({}, state, {
        sidebarCollectionFiles: [],
      });
    }

    case SET_COLLECTION_GROUP_GROUPS:
      return Object.assign({}, state, {
        collectionGroupGroups: action.collectionGroupGroups,
      });

    case DELETE_COLLECTION_GROUP_GROUP_FROM_LIST: {
      let newCollectionGroupGroups = state.collectionGroupGroups.slice(0);
      newCollectionGroupGroups = newCollectionGroupGroups.filter(cg => (cg.id !== action.groupId));

      return Object.assign({}, state, {
        collectionGroupGroups: newCollectionGroupGroups,
      });
    }

    case SET_SELECTED_COLLECTIONS:
      return Object.assign({}, state, {
        selectedCollections: action.collections,
      });

    case ADD_SELECTED_COLLECTION:
      return Object.assign({}, state, {
        selectedCollections: window._.uniqBy(state.selectedCollections.concat([action.collection]), 'uuid'),
      });

    case ADD_SELECTED_COLLECTIONS:
      return Object.assign({}, state, {
        selectedCollections: window._.uniqBy(state.selectedCollections.concat(action.collections), 'uuid'),
      });

    case REMOVE_SELECTED_COLLECTION:
      return Object.assign({}, state, {
        selectedCollections:
          state.selectedCollections.filter(c => (c.uuid !== action.collectionUuid)),
        selectedAllCollections: false,
      });

    case CLEAR_SELECTED_COLLECTIONS:
      return Object.assign({}, state, {
        selectedCollections: [],
      });

    case SET_SELECTED_ALL_COLLECTIONS:
      return Object.assign({}, state, {
        selectedAllCollections: action.allCollectionsSelected,
      });

    case SHOW_COLLECTION_GROUP_EDIT_MODAL:
      return Object.assign({}, state, {
        collectionGroupEditModal: true,
      });

    case HIDE_COLLECTION_GROUP_EDIT_MODAL:
      return Object.assign({}, state, {
        collectionGroupEditModal: false,
      });

    case UPDATE_COLLECTIONS_TREE: {
      let tree = state.collectionsTree[action.source];
      tree = Object.assign({}, tree, action.collections.data);
      if (action.parentUuid) {
        if (tree[action.parentUuid]) {
          tree[action.parentUuid].children = Object.keys(action.collections.data);
        }
      } else {
        tree.root.children = Object.keys(action.collections.data);
      }

      const { sc } = action.collections;
      Object.keys(sc).forEach((uuid) => {
        if (!tree[uuid]) {
          tree[uuid] = {
            index: uuid,
            uuid,
            name: sc[uuid].name,
            children: [],
            hasChildren: typeof sc[uuid].has_children === 'undefined' ? true : sc[uuid].has_children,
            open: sc[uuid].open,
            searched: sc[uuid].searched,
          };
        }
        if (sc[uuid].parent_uuid) {
          if (!tree[sc[uuid].parent_uuid].children.includes(uuid)) {
            tree[sc[uuid].parent_uuid].children.push(uuid);
          }
        } else if (!tree.root.children.includes(uuid)) {
          tree.root.children.push(uuid);
        }
      });

      return Object.assign({}, state, {
        collectionsTree: Object.assign({}, state.collectionsTree, { [action.source]: tree }),
      });
    }

    case ADD_COLLECTION_TO_TREE: {
      let tree = state.collectionsTree[action.source];
      tree = Object.assign({}, tree, { [action.collection.uuid]: action.collection });
      if (action.collection.parentUuid) {
        if (tree[action.collection.parentUuid]) {
          tree[action.collection.parentUuid].children.unshift(action.collection.uuid);
        }
      } else {
        tree.root.children.unshift(action.collection.uuid);
      }

      return Object.assign({}, state, {
        collectionsTree: Object.assign({}, state.collectionsTree, { [action.source]: tree }),
      });
    }

    case UPDATE_COLLECTION_ON_TREE: {
      let tree = state.collectionsTree[action.source];
      if (tree[action.collection.uuid]) {
        tree[action.collection.uuid] = { ...tree[action.collection.uuid], ...action.collection };
      } else {
        tree = Object.assign({}, tree, { [action.collection.uuid]: action.collection });
      }

      if (action.collection.parentUuid) {
        if (tree[action.collection.parentUuid] && !tree[action.collection.parentUuid].children) {
          tree[action.collection.parentUuid].children = [];
        }

        if (
          tree[action.collection.parentUuid] &&
          tree[action.collection.parentUuid].children
            .filter(c => (c === action.collection.uuid)).length === 0
        ) {
          Object.keys(tree).forEach((v) => {
            tree[v].children = tree[v].children ?
              tree[v].children.filter(c => (c !== action.collection.uuid)) : [];
          });
          tree[action.collection.parentUuid].children.push(action.collection.uuid);
        }

        if (tree[`_${action.collection.parentUuid}`]) {
          delete tree[`_${action.collection.parentUuid}`];
        }
      } else if (
        tree.root.children.filter(c => (c === action.collection.uuid)).length === 0
      ) {
        Object.keys(tree).forEach((v) => {
          tree[v].children = tree[v].children ?
            tree[v].children.filter(c => (c !== action.collection.uuid)) : [];
        });
        tree.root.children.unshift(action.collection.uuid);
      }

      return Object.assign({}, state, {
        collectionsTree: Object.assign({}, state.collectionsTree, { [action.source]: tree }),
      });
    }

    case REMOVE_COLLECTION_FROM_TREE: {
      const tree = state.collectionsTree[action.source];
      delete tree[action.collectionUuid];

      return Object.assign({}, state, {
        collectionsTree: Object.assign({}, state.collectionsTree, { [action.source]: tree }),
      });
    }

    case CLEAR_COLLECTIONS_TREE: {
      return Object.assign({}, state, {
        collectionsTree: Object.assign(
          {},
          state.collectionsTree,
          { [action.source]: initialCollectionsTree },
        ),
      });
    }

    case SET_COLLECTIONS_TREE_LOADING:
      return Object.assign({}, state, {
        collectionsTreeLoading: action.loading,
      });

    case GET_FEATURED_COLLECTIONS:
      return Object.assign({}, state, {
        featuredCollections: action.collections,
      });

    case SET_FEATURED_COLLECTIONS_LOADING:
      return Object.assign({}, state, {
        featuredCollectionsLoading: action.loading,
      });

    case SWAP_COLLECTIONS: {
      const fi = action.firstItem;
      const si = action.secondItem;
      const { collections } = state;

      const fmi = collections.findIndex(f => (f.uuid === fi));
      const smi = collections.findIndex(f => (f.uuid === si));

      if (fmi >= 0 && smi >= 0) {
        return update(state, {
          collections: {
            $splice: [
              [fmi, 1],
              [smi, 0, collections[fmi]],
            ],
          },
        });
      }

      return Object.assign({}, state, {
        collections,
      });
    }

    default:
      return state;
  }
};
